/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTransactionCodeRequest,
  GetTransactionCodeResponse,
  ReorderTransactionCodesRequest,
  Result,
  UpdateTransactionCodeRequest,
} from '../models/index';
import {
    CreateTransactionCodeRequestFromJSON,
    CreateTransactionCodeRequestToJSON,
    GetTransactionCodeResponseFromJSON,
    GetTransactionCodeResponseToJSON,
    ReorderTransactionCodesRequestFromJSON,
    ReorderTransactionCodesRequestToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateTransactionCodeRequestFromJSON,
    UpdateTransactionCodeRequestToJSON,
} from '../models/index';

export interface ApiTransactionCodesGetRequest {
    xTenantID?: number;
}

export interface ApiTransactionCodesIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTransactionCodesIdPutRequest {
    id: number;
    updateTransactionCodeRequest: UpdateTransactionCodeRequest;
    xTenantID?: number;
}

export interface ApiTransactionCodesIdSoftDeletePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTransactionCodesPostRequest {
    createTransactionCodeRequest: CreateTransactionCodeRequest;
    xTenantID?: number;
}

export interface ApiTransactionCodesReorderPutRequest {
    reorderTransactionCodesRequest: ReorderTransactionCodesRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class TransactionCodesApi extends runtime.BaseAPI {

    /**
     * Retrieves all transaction codes
     * Get transaction codes
     */
    async apiTransactionCodesGetRaw(requestParameters: ApiTransactionCodesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTransactionCodeResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTransactionCodeResponseFromJSON));
    }

    /**
     * Retrieves all transaction codes
     * Get transaction codes
     */
    async apiTransactionCodesGet(requestParameters: ApiTransactionCodesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTransactionCodeResponse>> {
        const response = await this.apiTransactionCodesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a transaction code by its ID
     * Get transaction code by ID
     */
    async apiTransactionCodesIdGetRaw(requestParameters: ApiTransactionCodesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionCodeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTransactionCodesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTransactionCodeResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a transaction code by its ID
     * Get transaction code by ID
     */
    async apiTransactionCodesIdGet(requestParameters: ApiTransactionCodesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionCodeResponse> {
        const response = await this.apiTransactionCodesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing transaction code with the provided details
     * Update transaction code
     */
    async apiTransactionCodesIdPutRaw(requestParameters: ApiTransactionCodesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTransactionCodesIdPut().'
            );
        }

        if (requestParameters['updateTransactionCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTransactionCodeRequest',
                'Required parameter "updateTransactionCodeRequest" was null or undefined when calling apiTransactionCodesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTransactionCodeRequestToJSON(requestParameters['updateTransactionCodeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing transaction code with the provided details
     * Update transaction code
     */
    async apiTransactionCodesIdPut(requestParameters: ApiTransactionCodesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTransactionCodesIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes an existing transaction code by ID
     * Delete transaction code
     */
    async apiTransactionCodesIdSoftDeletePutRaw(requestParameters: ApiTransactionCodesIdSoftDeletePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTransactionCodesIdSoftDeletePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes/{id}/soft-delete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an existing transaction code by ID
     * Delete transaction code
     */
    async apiTransactionCodesIdSoftDeletePut(requestParameters: ApiTransactionCodesIdSoftDeletePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTransactionCodesIdSoftDeletePutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new transaction code with the provided details
     * Create transaction code
     */
    async apiTransactionCodesPostRaw(requestParameters: ApiTransactionCodesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTransactionCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'createTransactionCodeRequest',
                'Required parameter "createTransactionCodeRequest" was null or undefined when calling apiTransactionCodesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTransactionCodeRequestToJSON(requestParameters['createTransactionCodeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new transaction code with the provided details
     * Create transaction code
     */
    async apiTransactionCodesPost(requestParameters: ApiTransactionCodesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTransactionCodesPostRaw(requestParameters, initOverrides);
    }

    /**
     * Sets the display order of all active transaction codes. The list must contain every active code id exactly once. That order is used in Settings and in every staff/admin transaction-code picker.
     * Reorder transaction codes
     */
    async apiTransactionCodesReorderPutRaw(requestParameters: ApiTransactionCodesReorderPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reorderTransactionCodesRequest'] == null) {
            throw new runtime.RequiredError(
                'reorderTransactionCodesRequest',
                'Required parameter "reorderTransactionCodesRequest" was null or undefined when calling apiTransactionCodesReorderPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/transaction-codes/reorder`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderTransactionCodesRequestToJSON(requestParameters['reorderTransactionCodesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets the display order of all active transaction codes. The list must contain every active code id exactly once. That order is used in Settings and in every staff/admin transaction-code picker.
     * Reorder transaction codes
     */
    async apiTransactionCodesReorderPut(requestParameters: ApiTransactionCodesReorderPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTransactionCodesReorderPutRaw(requestParameters, initOverrides);
    }

}
